// extracted by mini-css-extract-plugin
export default {"productGrid":"ProductGrid_productGrid__ZIi+p"};